module.exports = __webpack_public_path__ + "static/media/note3.8a5a151b.wav";